import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';

const middlewareConfig = {
  middlewaresMap: {
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
